import React from 'react';
import {
  Flex,
  Box,
} from 'reflexbox/styled-components';
import styled from 'styled-components';

import Web3Connector from '../../../components/web3Connector';

import NavLink from '../navLink';

import LogoSvg from '../../../assets/img/logo_pink.png';

const Logo = styled.img`
  height: 40px;
`;

function Navbar() {
  return (
    <Flex
      paddingBottom="20px"
      alignItems="center"
      flexWrap="wrap"
    >
      <Box width={[1, 1 / 2]} p={[3]} textAlign={['center', 'left']}>
        <NavLink margin="0" to="/">
          <Logo src={LogoSvg} alt="Logo" />
        </NavLink>
      </Box>
      <Box mx="auto" />
      <Box width={[1, 1 / 2]} p={[3]} textAlign={['center', 'right']}>
        <Web3Connector />
      </Box>
    </Flex>
  );
}

export default Navbar;
